import { render, staticRenderFns } from "./df-section-links.vue?vue&type=template&id=db799c6a"
import script from "./df-section-links.ts?vue&type=script&lang=js&external"
export * from "./df-section-links.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports